// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const newReports = [] as string[];

export const isNewReport = (key: string) => newReports.includes(key);
